<template>
    <div style="text-align:center;padding:30px;">
        <img src="../assets/media/apps/loading.gif" style="width:20%;"/>
    </div>
</template>
<script>
export default {
    name: "LoadingMobile"
}
</script>